const zoomCoef = 1.1892;

export const calculateNextZoom = (isIn: boolean, prevZoom: number): number =>
  isIn ? prevZoom * zoomCoef : prevZoom / zoomCoef;
